import React from 'react';
import Icon from '@ant-design/icons';
import { Trans } from 'react-i18next';
import { ReactComponent as SingleCheck } from '../../../../assets/icons/chatStatuses/singleCheck.svg';
import './DepartmentItemStyles.scss';
const DepartmentItem = ({ department, isActive, setDepartment, activeAgentsCount }) => {
    return (React.createElement("div", { className: isActive ? 'conversation-list-item department-item department-item__active' : 'department-item conversation-list-item', onClick: () => setDepartment(department._id) },
        React.createElement("div", { className: "conversation-photo department-item__avatar", style: { background: department.color } }),
        React.createElement("div", { className: 'conversation-info' },
            React.createElement("div", { className: "conversation-title-wrapper" },
                React.createElement("h1", { className: "conversation-title" }, department.name),
                React.createElement("p", { className: "conversation-message" },
                    React.createElement(Trans, { i18nKey: "numberOfAgents", count: activeAgentsCount !== null && activeAgentsCount !== void 0 ? activeAgentsCount : 0 }))),
            isActive && (React.createElement("div", { className: "conversation-status-block department-item__img-container" },
                React.createElement(Icon, { component: SingleCheck, className: 'department-item__img' }))))));
};
export default DepartmentItem;
